const SELECTOR = '.simple-text-block';

let lastWidth = window.innerWidth;
let resizeTimer = null;

function equalizeMinHeights() {
    const $blocks = $(SELECTOR);
    if (!$blocks.length) return;

    // Reset first (so heights are measured naturally)
    $blocks.css('min-height', '');

    let maxH = 0;

    $blocks.each(function () {
        const h = $(this).outerHeight(); // includes padding
        if (h > maxH) maxH = h;
    });

    if (maxH > 0) {
        $blocks.css('min-height', maxH + 'px');
    }
}

function onResize() {
    const w = window.innerWidth;

    // Ignore "resize" events caused only by height changes (mobile address bar / UI)
    if (w === lastWidth) return;
    lastWidth = w;

    // Debounce
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        equalizeMinHeights();
    }, 120);
}

$(function () {
    equalizeMinHeights();

    // Recalc after images/fonts load can change heights
    $(window).on('load', equalizeMinHeights);

    $(window).on('resize orientationchange', onResize);
});